module.exports = __webpack_public_path__ + "static/media/js.980ad8da.svg";